import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { theme } from 'styles/theme';
import { Select } from './Select';
import { css } from '@emotion/react';

import { IconCzech } from 'icons/IconCzech';
import { IconSlovakia } from 'icons/IconSlovakia';

export const PhoneInput = ({
	error,
	width,
	onChange,
	value,
	sizeMedium,
	placeholder,
}: {
	width: number;
	onChange: (value: string) => void;
	value: string;
	sizeMedium?: boolean;
	placeholder?: string;

	error: any;
}) => {
	const defaultPrefix = '+420';

	const inputRef = useRef<HTMLInputElement>(null);
	const [cursor, setCursor] = useState<number | null>(null);

	const [phoneNumber, setPhoneNumber] = useState('');
	const [prefix, setPrefix] = useState<string>(defaultPrefix);

	useEffect(() => {
		const input = inputRef.current;

		if (value) {
			const extractedPrefix = value.match(/^\+(\d+)/);
			const newPrefix = extractedPrefix ? extractedPrefix[0] : defaultPrefix;

			const newNumber = value.replace(/^\+\d+/, '').replace(/^\s+/, '');

			setPrefix(newPrefix);
			setPhoneNumber(newNumber); // Remove the existing prefix
		}

		if (input) {
			input.setSelectionRange(cursor, cursor);
		}
	}, [value, onChange, prefix, phoneNumber, inputRef, cursor]);

	const handleChangeNumber = (e: ChangeEvent<HTMLInputElement>) => {
		setCursor(e.target.selectionStart);
		onChange(prefix + ' ' + e.target.value);
	};
	const handleChangePrefix = (value: string) => {
		onChange(value + ' ' + phoneNumber);
	};

	// alert(value);

	return (
		<div
			css={css`
				display: flex;
				width: 100%;

				${width &&
				css`
					width: ${width}px;
				`}
			`}
		>
			<div
				css={css`
					display: flex;
					font-size: 14px;
					line-height: 20px;

					width: 100%;

					height: ${sizeMedium ? 36 : 44}px;

					border: 1px solid #d4d5de;
					border-radius: 8px;

					${!!error &&
					css`
						border-color: #ff6767;
					`}
				`}
			>
				<div
					css={css`
						display: flex;
						flex-shrink: 0;
						width: 112px;
					`}
				>
					<Select
						value={prefix}
						options={[
							{ label: '+420', value: '+420', icon: <IconCzech /> },
							{ label: '+421', value: '+421', icon: <IconSlovakia /> },
						]}
						onChange={handleChangePrefix}
						isCompositePrefix
					/>
				</div>

				<input
					ref={inputRef}
					css={css`
						border: 0;
						background: transparent;
						padding-left: 8px;

						width: 100%;

						border-radius: 0 8px 8px 0;

						::placeholder {
							color: #8c8fa6;
						}

						&:focus {
							outline: none;
							box-shadow: 0 0 0 2px ${theme.color.primary['400']};
							border-color: transparent;
						}
					`}
					type="text"
					value={phoneNumber}
					onChange={handleChangeNumber}
					placeholder={placeholder}
				/>
			</div>
		</div>
	);
};
